import React, { Component } from 'react';

export class WhatsAppButton extends Component {
  static displayName = WhatsAppButton.name;

  handleWhatsAppClick = () => {
    const phoneNumber = "573023772270"; // Número de WhatsApp de la iglesia
    const message = "Hola! Me interesa conocer más sobre la Iglesia CBR. ¿Podrían darme más información?";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  render() {
    return (
      <button 
        className="whatsapp-button"
        onClick={this.handleWhatsAppClick}
        title="Contáctanos por WhatsApp"
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          width: '60px',
          height: '60px',
          background: '#25D366',
          border: 'none',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 12px rgba(37, 211, 102, 0.4)',
          zIndex: 1000,
          transition: 'all 0.3s ease',
          color: 'white',
          fontSize: '24px',
          cursor: 'pointer'
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'scale(1.1)';
          e.target.style.boxShadow = '0 6px 20px rgba(37, 211, 102, 0.6)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'scale(1)';
          e.target.style.boxShadow = '0 4px 12px rgba(37, 211, 102, 0.4)';
        }}
      >
        <i className="fab fa-whatsapp"></i>
      </button>
    );
  }
}
